import {BreadCrumb} from "pages/common/BreadCrumb"
import {TitleInDetailPage} from "pages/common/TitleInDetailPage"
import {PageTabInDetailPage, PageTabItemInDetailPage} from "pages/common/PageTabInDetailPage"
import {Outlet, useNavigate, useParams} from "react-router-dom"
import {useFindUserById} from "hooks/query/user-query"
import {UpdateUserForm} from "pages/user/UpdateUserForm"
import {UpdateUserAttribute} from "pages/user/UpdateUserAttribute"
import {UpdateUserPassword} from "pages/user/UpdateUserPassword"
import {UpdateUserRoleMapping} from "pages/user/UpdateUserRoleMapping"
import {UpdateUserGroup} from "pages/user/UpdateUserGroup"
import {UpdateUserSession} from "pages/user/UpdateUserSession"

export function UpdateUserView() {
    const {id, view} = useParams<{ id: string, view: string }>()
    const navigate = useNavigate()
    const {data: user} = useFindUserById(id)
    if (!user) return <div>Loading...</div>
    return (
        <div className="main-body">
            <BreadCrumb title="User" subTitle={`/ ${user?.username}`}/>
            <div className="sub-panel">
                <TitleInDetailPage title={user?.username || ""} iconPath="/img/icon-users.png"/>
                <div className="sub-content-box">
                    <PageTabInDetailPage>
                        <PageTabItemInDetailPage title="사용자 정보" active={view === "form"} iconClass="fa-rectangle-list"
                                                 onClick={() => navigate(`/user/update/${id}/form`)}/>
                        <PageTabItemInDetailPage title="Attributes" active={view === "attribute"}
                                                 iconClass="fa-list-check"
                                                 onClick={() => navigate(`/user/update/${id}/attribute`)}/>
                        <PageTabItemInDetailPage title="비밀번호변경" active={view === "password"}
                                                 iconClass="fa-link"
                                                 onClick={() => navigate(`/user/update/${id}/password`)}/>
                        <PageTabItemInDetailPage title="Rol Mapping" active={view === "role-mapping"}
                                                 iconClass="fa-link"
                                                 onClick={() => navigate(`/user/update/${id}/role-mapping`)}/>
                        <PageTabItemInDetailPage title="Groups" active={view === "group"} iconClass="fa-user-check"
                                                 onClick={() => navigate(`/user/update/${id}/group`)}/>
                        <PageTabItemInDetailPage title="Sessions" active={view === "session"} iconClass="fa-user-check"
                                                 onClick={() => navigate(`/user/update/${id}/session`)}/>
                    </PageTabInDetailPage>
                    {view === "form" && (<UpdateUserForm/>)}
                    {view === "attribute" && (<UpdateUserAttribute/>)}
                    {view === "password" && (<UpdateUserPassword/>)}
                    {view === "role-mapping" && (<UpdateUserRoleMapping/>)}
                    {view === "group" && (<UpdateUserGroup/>)}
                    {view === "session" && (<UpdateUserSession/>)}
                    <Outlet/>
                </div>
            </div>
        </div>
    )
}